<template lang="pug">
.player(v-if="currentVideo", :class="{ collapsed, 'nudge-right': insightsShown && !chartShown }", :style="{ 'z-index': insightsShown && !chartShown && 1001 || 18003 }")
  .top-bar
    .control-strip
      .skip.back(@click="prev", :class="{ hidden: !playlist || !prevVideo }")
        .play-pause.control(paused="true")
        .play-pause.control(paused="true")
      .play-pause.control(:paused="!playing", @click="playPause", :class="{ hidden: !player }")
      .skip(@click="next", :class="{ hidden: !playlist || !nextVideo }")
        .play-pause.control(paused="true")
        .play-pause.control(paused="true")
      .vid-title {{ currentVideo.t }}
      .fullscreen.control(@click="toggleFullScreen", :class="{ hidden: !player }")

    //.button.collapse(@click="playlist = null")
    //.button.close(@click="playlist = null") &times;
  youtube.youtube(:video-id="id",
                  v-if="id",
                  @buffering="onPlaying",
                  @playing="onPlaying",
                  @paused="paused",
                  @ended="ended",
                  ref="youtube",
                  player-width="100%",
                  player-height="100%",
                  :player-vars="{ modestbranding: 1, playsinline: 1, rel: 0, autoplay: 1 }")
  .side-bar
    .button.close(@click="currentVideo = null") &times;
    .button.collapse(@click="collapsed = !collapsed", :class="{ collapsed }")
</template>
<script>
import VueYouTubeEmbed from 'vue-youtube-embed';
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
export default {
  name: 'player',
  data() {
    return { id: null };
  },
  computed: {
    ...mapGetters(['prevVideo', 'nextVideo', 'insightsShown', 'chartShown']),
    ...vuexComputed('playlist', 'currentVideo', 'player', 'playing', 'collapsed', 'engagePlaying')
  },
  watch: {
    currentVideo(newValue, oldValue) {
      if (this.player) {
        console.log('have player play vid', newValue, oldValue);
        if (newValue?.id) {
          this.player?.loadVideoById(newValue.id);
          //setTimeout(() => this.player?.playVideo(), 400);
        }
      } else {
        if (newValue?.id) {
          console.log('no player', newValue.id);
          this.id = newValue.id;
        }
      }
    }
  },
  methods: {
    ...mapActions(['videoPauseEvent', 'toggleFullScreenEvent']),
    onPlaying(yt) {
      const { target: player } = yt || {};
      console.log('playing!', player, this.currentVideo.id);
      this.playing = true;
      this.player = player;
      this.engagePlaying = true;
    },
    paused() {
      console.log('paused', this.currentVideo.id);
      this.playing = false;
      this.engagePlaying = false;
      this.videoPauseEvent();
    },
    ended() {
      this.playing = false;
      this.engagePlaying = false;
      this.next();
      //console.log('ended', this.currentVideo.id);
    },
    playPause() {
      this.player[(this.playing && 'pauseVideo') || 'playVideo']();
      this.engagePlaying = this.playing = !this.playing;
    },
    next() {
      this.$store.dispatch('nextVideo');
    },
    prev() {
      this.$store.dispatch('prevVideo');
    },
    toggleFullScreen() {
      const yt = this.$refs.youtube;
      const iframe = (yt && yt.$el && yt.$el.querySelector('iframe')) || {};
      const requestFullScreen =
        iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullScreen;
      if (requestFullScreen) {
        requestFullScreen.bind(iframe)();
        this.toggleFullScreenEvent();
      }
    }
  },
  mounted() {
    const { currentVideo } = this;
    if (currentVideo.id) {
      this.id = currentVideo.id;
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.player {
  position: fixed;
  object-fit: contain;
  width: 100%;
  @include large {
    //width: 33%;
    width: 583px;
    height: 292px;
    transform: translate3d(0, 0, 0);
    transition: transform 400ms ease-in-out;
    will-change: transform;
    &.nudge-right {
      transform: translate3d(20.25vw, 0, 0);
      &.collapsed {
        transform: translate3d(calc(-583px + 20.25vw), 0, 0);
      }
    }
    &.collapsed {
      transform: translate3d(-583px, 0, 0);
    }
  }
  height: 50%;
  left: 0;
  bottom: 0;
  z-index: 16005;
  .control-strip {
    position: absolute;
    top: 0;
    height: 2rem;
    padding-top: 0.3rem;
    background-color: rgba(40, 40, 40, 0.85);
    display: flex;
    width: 100%;
    box-sizing: border-box;
    padding-left: 1rem;
    .hidden {
      pointer-events: none;
      opacity: 0;
    }
    .skip {
      display: flex;
      justify-content: flex-start;
      margin-right: 3rem;
      box-sizing: border-box;
      position: relative;
      top: 0;
      //padding-top: 0.5rem;
      //padding-bottom: 0.25rem;
      .control.play-pause {
        margin-right: -0.47rem;
        background-position: center center;
        position: static;
        &[paused='true'] {
          height: 1.1rem;
          width: 1.1rem;
        }
      }
      &.back {
        position: relative;
        left: 1.5rem;
        top: -0.35rem;
        transform: rotate(180deg);
      }
    }
    .control {
      cursor: pointer;
      height: 1.5rem;
      width: 1.5rem;
      margin-right: 1rem;
      background: no-repeat;
      &.play-pause {
        height: 2rem;
        width: 2rem;
        position: relative;
        // pause svg
        background-image: url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' width%3D'48' height%3D'48' viewBox%3D'0 0 48 48'%3E%3Cpath d%3D'M12 38h8V10h-8v28zm16-28v28h8V10h-8z' fill%3D'%23fff'/%3E%3C/svg%3E");
        background-size: contain;
        &[paused='true'] {
          height: 2.25rem;
          width: 2.25rem;
          top: -0.25rem;
          // play svg
          background-image: url("data:image/svg+xml;charset%3Dutf8,%3C?xml version%3D'1.0' encoding%3D'UTF-8' standalone%3D'no'?%3E%3Csvg xmlns:svg%3D'http://www.w3.org/2000/svg' xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'0 -256 1792 1792'%3E%3Cg transform%3D'matrix(1,0,0,-1,227.79661,1258.2034)' id%3D'g3003'%3E%3Cpath d%3D'M 1384,609 56,-129 Q 33,-142 16.5,-132 0,-122 0,-96 v 1472 q 0,26 16.5,36 16.5,10 39.5,-3 L 1384,671 q 23,-13 23,-31 0,-18 -23,-31 z' style%3D'fill:%23fff'/%3E%3C/g%3E%3C/svg%3E");
          background-position: center 3px;
        }
      }
      &.stop::after {
        position: relative;
        top: -2.5rem;
        left: -0.5rem;
        color: white;
        font-size: 6rem;
        content: '\00d7';
      }
      &.fullscreen {
        //position: absolute;
        //right: 0;
        width: 2.2rem;
        height: 2.2rem;
        background-image: url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' width%3D'36' height%3D'36' viewBox%3D'0 0 36 36'%3E%3Cpath fill%3D'white'  d%3D'M10 21h-3v8h8v-3h-5v-5zm-3-6h3v-5h5v-3h-8v8zm19 11h-5v3h8v-8h-3v5zm-5-19v3h5v5h3v-8h-8z'/%3E%3C/svg%3E");
        background-size: 100%;
      }
    }
    .vid-title {
      color: white;
      font-size: 1.2rem;
      white-space: nowrap;
      overflow: hidden;
      width: 35rem;
      margin-left: -2rem;
      text-overflow: ellipsis;
      padding-right: 0.5rem;
      padding-bottom: 0.5rem;
    }
  }
  .top-bar {
    position: absolute;
    top: 7.5rem;
    right: 0.5rem;
    .button {
      padding: 0.3rem 1rem;
      color: white;
      cursor: default;
      border: 2px solid white;
      border-radius: 50%;
      white-space: nowrap;
      top: 50%;
      left: 50%;
      background-color: rgba(40, 40, 40, 0.25);
      transform: translate3d(0, -100%, 0);
      &.close {
        padding-top: 0;
        font-size: 3rem;
      }
    }
    @include large {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      transform: translate3d(0, -100%, 0);
      height: 2rem;
      background-color: rgba(40, 40, 40, 0.9);
      display: flex;
      justify-content: flex-end;
      .button {
        position: static;
        //padding: 0.3rem 1rem;
        color: white;
        cursor: pointer;
        border-width: 0;
        border-radius: 50%;
        white-space: nowrap;
        background-color: transparent;
        top: 0;
        left: 0;
        /*background-color: rgba(40, 40, 40, 0.25);*/
        transform: translate3d(0, 0, 0);
        font-size: 1.5rem;
        padding-top: 0;
        &.close {
          font-size: 1.5rem;
          padding-top: 0;
        }
        &.collapse {
          &::after {
            display: inline-block;
            width: 2rem;
            height: 2rem;
            content: '\BB';
            transform-origin: center;
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  .youtube {
    width: 100%;
    height: 100%;
  }
  .side-bar {
    @include large {
      position: absolute;
      left: 100%;
      top: -2rem;
      height: 324px;
      width: 2rem;
      background-color: rgba(40, 40, 40, 0.9);
      .button {
        position: static;
        padding: 0.3rem;
        color: white;
        cursor: pointer;
        border-width: 0;
        border-radius: 50%;
        white-space: nowrap;
        background-color: transparent;
        top: 0;
        left: 0;
        /*background-color: rgba(40, 40, 40, 0.25);*/
        transform: translate3d(0, 0, 0);
        font-size: 1.5rem;
        padding-top: 0;
        &.close {
          font-size: 1.5rem;
          padding-top: 0;
          padding-left: 0.5rem;
        }
        &.collapse {
          position: relative;
          left: -1rem;
          padding-top: 8rem;
          &::after {
            display: inline-block;
            width: 2rem;
            height: 2rem;
            content: '\BB';
            transform-origin: center;
            transform: rotate(180deg);
          }
          &.collapsed {
            &::after {
              transform: rotate(0) translate3d(1.25rem, 0, 0);
            }
          }
        }
      }
    }
  }
  &.docked {
  }
  iframe {
    width: 100%;
    height: 100%;
    /*object-fit: contain;*/
  }
}
</style>
